
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexV5N6QzXoD8Meta } from "/codebuild/output/src681243601/src/pages/index.vue?macro=true";
import { default as about6Lylmk64KsMeta } from "/codebuild/output/src681243601/src/pages/about.vue?macro=true";
import { default as dataM2sbLkr144Meta } from "/codebuild/output/src681243601/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionODeSTAalR5Meta } from "/codebuild/output/src681243601/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningSnrI1kZYXCMeta } from "/codebuild/output/src681243601/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyrM5vMHtZXXMeta } from "/codebuild/output/src681243601/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45account54dItJYn7aMeta } from "/codebuild/output/src681243601/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statueBddumQSwNIMeta } from "/codebuild/output/src681243601/src/pages/account-settings/statue.vue?macro=true";
import { default as supportspcsH9hJxqMeta } from "/codebuild/output/src681243601/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsVQuQUm2QfpMeta } from "/codebuild/output/src681243601/src/pages/account-settings.vue?macro=true";
import { default as activate_45account77p6CkrA7eMeta } from "/codebuild/output/src681243601/src/pages/activate-account.vue?macro=true";
import { default as companysQq32YNb3BMeta } from "/codebuild/output/src681243601/src/pages/admin/company.vue?macro=true";
import { default as consentsh79O3VdQ0KMeta } from "/codebuild/output/src681243601/src/pages/admin/consents.vue?macro=true";
import { default as leads0m9XAz55eMMeta } from "/codebuild/output/src681243601/src/pages/admin/leads.vue?macro=true";
import { default as paymentswzcE7lA4IWMeta } from "/codebuild/output/src681243601/src/pages/admin/payments.vue?macro=true";
import { default as premiumBjHiREzxlvMeta } from "/codebuild/output/src681243601/src/pages/admin/premium.vue?macro=true";
import { default as profilesqtz9fzMBdCMeta } from "/codebuild/output/src681243601/src/pages/admin/profiles.vue?macro=true";
import { default as usersHPiIOzVRpdMeta } from "/codebuild/output/src681243601/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordMQ8Ac6xBR7Meta } from "/codebuild/output/src681243601/src/pages/change-password.vue?macro=true";
import { default as _91id_93aCfNn73KMOMeta } from "/codebuild/output/src681243601/src/pages/chat/[id].vue?macro=true";
import { default as ai7DiuUuPNC5Meta } from "/codebuild/output/src681243601/src/pages/chat/ai.vue?macro=true";
import { default as indexmxGD5jEuphMeta } from "/codebuild/output/src681243601/src/pages/chat/index.vue?macro=true";
import { default as chatRQpZLJHxYeMeta } from "/codebuild/output/src681243601/src/pages/chat.vue?macro=true";
import { default as _91id_93eZdenSlrbkMeta } from "/codebuild/output/src681243601/src/pages/client/profile/[id].vue?macro=true";
import { default as indexaxHvRE6KvyMeta } from "/codebuild/output/src681243601/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_935MoaSqxD2vMeta } from "/codebuild/output/src681243601/src/pages/contacts/[id].vue?macro=true";
import { default as indexL6lnWIT3RCMeta } from "/codebuild/output/src681243601/src/pages/contacts/index.vue?macro=true";
import { default as contacts4smdzNrYAJMeta } from "/codebuild/output/src681243601/src/pages/contacts.vue?macro=true";
import { default as _91userId_93Varga9XTl4Meta } from "/codebuild/output/src681243601/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexsthMMzQJCUMeta } from "/codebuild/output/src681243601/src/pages/login/index.vue?macro=true";
import { default as register_45successp7dgRQdWNnMeta } from "/codebuild/output/src681243601/src/pages/login/register-success.vue?macro=true";
import { default as logintHIXdUoiCVMeta } from "/codebuild/output/src681243601/src/pages/login.vue?macro=true";
import { default as logoutNCBYuT0kz8Meta } from "/codebuild/output/src681243601/src/pages/logout.vue?macro=true";
import { default as consentsQ49lySkgsmMeta } from "/codebuild/output/src681243601/src/pages/manager/consents.vue?macro=true";
import { default as integrationsO8jrC9eUHBMeta } from "/codebuild/output/src681243601/src/pages/manager/integrations.vue?macro=true";
import { default as leadsbCoP85D4yJMeta } from "/codebuild/output/src681243601/src/pages/manager/leads.vue?macro=true";
import { default as paymentsMkP4vjLUP8Meta } from "/codebuild/output/src681243601/src/pages/manager/payments.vue?macro=true";
import { default as profileF3T2fYyA7KMeta } from "/codebuild/output/src681243601/src/pages/manager/profile.vue?macro=true";
import { default as teamZwHi8atfiCMeta } from "/codebuild/output/src681243601/src/pages/manager/team.vue?macro=true";
import { default as indexSXRfDCNk3IMeta } from "/codebuild/output/src681243601/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientM7kIG6eb23Meta } from "/codebuild/output/src681243601/src/pages/marketplace/search/[catId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src681243601/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as marketplaces1b8FRtR6nMeta } from "/codebuild/output/src681243601/src/pages/marketplace.vue?macro=true";
import { default as subscribe4aOODvK2kPMeta } from "/codebuild/output/src681243601/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientne8qVGWP6eMeta } from "/codebuild/output/src681243601/src/pages/orders/find.client.vue?macro=true";
import { default as my_46client4PBRqMTzYMMeta } from "/codebuild/output/src681243601/src/pages/orders/my.client.vue?macro=true";
import { default as privacyDErr8QsmPxMeta } from "/codebuild/output/src681243601/src/pages/privacy.vue?macro=true";
import { default as indexfv9XilRqy6Meta } from "/codebuild/output/src681243601/src/pages/recover/index.vue?macro=true";
import { default as successUFThcnDwvlMeta } from "/codebuild/output/src681243601/src/pages/register/success.vue?macro=true";
import { default as _91id_933WpOZo81BbMeta } from "/codebuild/output/src681243601/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexlBxZnP5niiMeta } from "/codebuild/output/src681243601/src/pages/sales/profile/index.vue?macro=true";
import { default as statueHWvDJUxpwrMeta } from "/codebuild/output/src681243601/src/pages/statue.vue?macro=true";
import { default as successxsmXMFQ8TdMeta } from "/codebuild/output/src681243601/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubOaSvOyfOAKMeta } from "/codebuild/output/src681243601/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubOaSvOyfOAK } from "/codebuild/output/src681243601/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexV5N6QzXoD8Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: about6Lylmk64KsMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: about6Lylmk64KsMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsVQuQUm2QfpMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsVQuQUm2QfpMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src681243601/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45account77p6CkrA7eMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45account77p6CkrA7eMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companysQq32YNb3BMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companysQq32YNb3BMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentsh79O3VdQ0KMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentsh79O3VdQ0KMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leads0m9XAz55eMMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leads0m9XAz55eMMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentswzcE7lA4IWMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentswzcE7lA4IWMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumBjHiREzxlvMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumBjHiREzxlvMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesqtz9fzMBdCMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesqtz9fzMBdCMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersHPiIOzVRpdMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersHPiIOzVRpdMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordMQ8Ac6xBR7Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordMQ8Ac6xBR7Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/change-password.vue")
  },
  {
    name: chatRQpZLJHxYeMeta?.name,
    path: "/en/chat",
    meta: chatRQpZLJHxYeMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___en",
    path: ":id()",
    meta: _91id_93aCfNn73KMOMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "ai",
    meta: ai7DiuUuPNC5Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/chat/ai.vue")
  },
  {
    name: "chat___en",
    path: "",
    meta: indexmxGD5jEuphMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/chat/index.vue")
  }
]
  },
  {
    name: chatRQpZLJHxYeMeta?.name,
    path: "/pl/chat",
    meta: chatRQpZLJHxYeMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___pl",
    path: ":id()",
    meta: _91id_93aCfNn73KMOMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___pl",
    path: "ai",
    meta: ai7DiuUuPNC5Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/chat/ai.vue")
  },
  {
    name: "chat___pl",
    path: "",
    meta: indexmxGD5jEuphMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/chat/index.vue")
  }
]
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93eZdenSlrbkMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93eZdenSlrbkMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexaxHvRE6KvyMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexaxHvRE6KvyMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/client/profile/index.vue")
  },
  {
    name: contacts4smdzNrYAJMeta?.name,
    path: "/en/contacts",
    meta: contacts4smdzNrYAJMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_935MoaSqxD2vMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexL6lnWIT3RCMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contacts4smdzNrYAJMeta?.name,
    path: "/pl/contacts",
    meta: contacts4smdzNrYAJMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_935MoaSqxD2vMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexL6lnWIT3RCMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93Varga9XTl4Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93Varga9XTl4Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexV5N6QzXoD8Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexV5N6QzXoD8Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/index.vue")
  },
  {
    name: logintHIXdUoiCVMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src681243601/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexsthMMzQJCUMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successp7dgRQdWNnMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: logintHIXdUoiCVMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src681243601/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexsthMMzQJCUMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successp7dgRQdWNnMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutNCBYuT0kz8Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutNCBYuT0kz8Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsQ49lySkgsmMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsQ49lySkgsmMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsO8jrC9eUHBMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsO8jrC9eUHBMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsbCoP85D4yJMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsbCoP85D4yJMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsMkP4vjLUP8Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsMkP4vjLUP8Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profileF3T2fYyA7KMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profileF3T2fYyA7KMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamZwHi8atfiCMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamZwHi8atfiCMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/manager/team.vue")
  },
  {
    name: marketplaces1b8FRtR6nMeta?.name,
    path: "/en/marketplace",
    meta: marketplaces1b8FRtR6nMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src681243601/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientM7kIG6eb23Meta || {},
    component: () => createClientPage(() => import("/codebuild/output/src681243601/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaces1b8FRtR6nMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaces1b8FRtR6nMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src681243601/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientM7kIG6eb23Meta || {},
    component: () => createClientPage(() => import("/codebuild/output/src681243601/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribe4aOODvK2kPMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribe4aOODvK2kPMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientne8qVGWP6eMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src681243601/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientne8qVGWP6eMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src681243601/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46client4PBRqMTzYMMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src681243601/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46client4PBRqMTzYMMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src681243601/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacyDErr8QsmPxMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacyDErr8QsmPxMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexfv9XilRqy6Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexfv9XilRqy6Meta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src681243601/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src681243601/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_933WpOZo81BbMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_933WpOZo81BbMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexlBxZnP5niiMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexlBxZnP5niiMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statueHWvDJUxpwrMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statueHWvDJUxpwrMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successxsmXMFQ8TdMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successxsmXMFQ8TdMeta || {},
    component: () => import("/codebuild/output/src681243601/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubOaSvOyfOAKMeta?.name,
    path: "/old-page",
    component: component_45stubOaSvOyfOAK
  }
]